import React from 'react';
import { Link } from 'react-router-dom';
import { Users, School, UserCheck, Settings } from 'lucide-react';
import { useTranslation } from '../i18n/useTranslation';

export default function CoachDashboard() {
  const { t } = useTranslation();
  
  return (
    <div className='max-w-4xl mx-auto px-4 py-8'>
      <div className='mb-8'>
        <h1 className='text-2xl md:text-3xl font-bold text-primary-600 mb-4 italic'>
          {t('coachDashboard.title')}
        </h1>
        <p className='text-gray-600'>
          {t('coachDashboard.subtitle')}
        </p>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        {/* Student Management */}
        <Link
          to='/student-management'
          className='bg-white shadow rounded-lg p-6 hover:shadow-lg transition-shadow group'
        >
          <div className='flex items-center mb-4'>
            <div className='w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center group-hover:bg-primary-200 transition-colors'>
              <Users className='h-6 w-6 text-primary-600' />
            </div>
            <div className='ml-4'>
              <h2 className='text-xl font-semibold text-gray-900'>
                {t('coachDashboard.studentManagement')}
              </h2>
              <p className='text-gray-600'>
                {t('coachDashboard.manageStudentsAndSessions')}
              </p>
            </div>
          </div>
          <div className='space-y-2 text-sm text-gray-600'>
            <div className='flex items-center'>
              <UserCheck className='h-4 w-4 mr-2' />
              <span>{t('coachDashboard.trackStudentProgress')}</span>
            </div>
            <div className='flex items-center'>
              <Settings className='h-4 w-4 mr-2' />
              <span>{t('coachDashboard.planPracticeSessions')}</span>
            </div>
            <div className='flex items-center'>
              <School className='h-4 w-4 mr-2' />
              <span>{t('coachDashboard.monitorDevelopment')}</span>
            </div>
          </div>
        </Link>

        {/* Goalie School Profile */}
        <Link
          to='/coach-profile'
          className='bg-white shadow rounded-lg p-6 hover:shadow-lg transition-shadow group'
        >
          <div className='flex items-center mb-4'>
            <div className='w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center group-hover:bg-primary-200 transition-colors'>
              <School className='h-6 w-6 text-primary-600' />
            </div>
            <div className='ml-4'>
              <h2 className='text-xl font-semibold text-gray-900'>
                {t('coachDashboard.goalieSchoolProfile')}
              </h2>
              <p className='text-gray-600'>
                {t('coachDashboard.manageCoachingProfile')}
              </p>
            </div>
          </div>
          <div className='space-y-2 text-sm text-gray-600'>
            <div className='flex items-center'>
              <UserCheck className='h-4 w-4 mr-2' />
              <span>{t('coachDashboard.publicCoachingProfile')}</span>
            </div>
            <div className='flex items-center'>
              <Settings className='h-4 w-4 mr-2' />
              <span>{t('coachDashboard.servicesAndPricing')}</span>
            </div>
            <div className='flex items-center'>
              <School className='h-4 w-4 mr-2' />
              <span>{t('coachDashboard.contactInformation')}</span>
            </div>
          </div>
        </Link>
      </div>

      <div className='mt-8 bg-primary-50 border border-primary-200 rounded-lg p-6'>
        <h3 className='text-lg font-semibold text-primary-900 mb-2'>
          {t('coachDashboard.gettingStartedAsCoach')}
        </h3>
        <p className='text-primary-700 mb-4'>
          {t('coachDashboard.setupProfileDescription')}
        </p>
        <div className='space-y-2 text-sm text-primary-600'>
          <p>
            • {t('coachDashboard.createGoalieSchoolProfile')}
          </p>
          <p>
            • {t('coachDashboard.addStudentsToTrack')}
          </p>
          <p>
            • {t('coachDashboard.useAnalyticsTools')}
          </p>
        </div>
      </div>
    </div>
  );
}